export default "__VITE_ASSET__691ceeda__"